<template>
  <div class="page-header-index-wide">

    <a-row  :gutter="24" >
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px'}" >
        <a-card style="height: 500px" :title="language['home.todo']">
          <a-table size="middle"
                   bordered
                   :columns="this.columns"
                   :data-source="this.sourceBacklog">
            <span slot="details" slot-scope="text, record">
              <a @click="showCheckTableInfo(record)">{{language['show.detail']}}</a>
            </span>
          </a-table>

        </a-card>

      </a-col>
      <a-col  justify="center"  :sm="12" :md="12" :xl="12"  :style="{ marginBottom: '24px'}">
        <a-card style="height: 500px;" :title="stateTitle" :body-style="{'text-align':'center'}">
          <a slot="extra" @click="showStateTableInfo">{{language['show.detail']}}</a>
          <pie :dataSource="this.sourceDataState" style="margin-right: 80px" />
        </a-card>
      </a-col>
    </a-row>

    <a-row  :gutter="24">
      <a-col justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px' }">
        <a-card style="height: 500px" :title="levelTitle">
          <a slot="extra" @click="showLevelTableInfo">{{language['show.detail']}}</a>
          <pie  :dataSource="this.sourceDataLevel" style="margin-right: 160px"/>
        </a-card>
      </a-col>
      <a-col  justify="center" :sm="12" :md="12" :xl="12" :style="{ marginBottom: '24px', }">
        <a-card style="height: 500px" :title="typeTitle">
          <a slot="extra" @click="showTypeTableInfo">{{language['show.detail']}}</a>
          <pie  :dataSource="this.sourceDataType" style="margin-right: 160px"/>
        </a-card>
      </a-col>
    </a-row>

  </div>
</template>

<script>
  import Pie from '@/components/chart/Pie'
  import { getAction, postAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'HomeIndexTo',
   // mixins:[JeecgListMixin],
    components:{
      Pie
    },
    data() {
      return {
        url: {
          danger_list: '/epm/epDanger/rectify_list',
          list: "/epm/report/getDangerLevelReportTo",
          report_state_list: "/epm/report/getDangerStateReportTo",
          listUnit: "/epm/report/queryDangerUnitList",
          report_type_list: '/epm/report/getDangerTypeReport',
          todo_list: "/sys/wfapi/getAllToDoTaskList",
        },

        parm: {
          pageNo : 1,
          pageSize : 10,
          inspectFlag:0,
          order:"desc",
          appCode:'env_audit',
          startTime : this.getOneMonthDate(),
          endTime: this.getNowDate(),
        },
        queryParam: {
          workNo:this.$store.getters.userInfo.workNo,
        },
        sourceBacklog: [],
        sourceDataState:[],
        sourceDataLevel:[],
        sourceDataType: [],
        height: 400,

        curData : '',
        stateTitle:'',
        levelTitle:'',
        typeTitle:'',

        total:{
          MF:0,
          TW:0,
          TA:0,
          TN:0,
          TS:0,
          TR:0,
          TH:0,
          DW:0,
          DA:0,
          EO:0,
          EM:0,
          sumTotal:0
        },
        dataList:[],
        dataSource:[],
        data:[],
        fields_list:[],
      }
    },
    watch: {
      '$route': function(to, from) {
        if(to.fullPath === '/HomeIndexTo'){
          this.sourceBacklog = []  //重置

          this.getTodoList();
          this.getDangerList()
          this.getDangerLevel()
          this.getDangerState()
          this.getDangerType()

          let yy = new Date().getFullYear();
          let mm = new Date().getMonth()+1;

          this.curData = yy + '/' + mm
          this.stateTitle = this.language['danger.state.table']  + "(" + this.curData + ")"
          this.levelTitle = this.language['danger.level.table']  + "(" + this.curData + ")"
          this.typeTitle =  this.language['danger.type.table'] + "(" + this.curData + ")"
        }
      }
    },
    created() {
      this.getTodoList();
      this.getDangerList()
      this.getDangerLevel()
      this.getDangerState()
      this.getDangerType()

      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;

      this.curData = yy + '/' + mm
      this.stateTitle = this.language['danger.state.table']  + "(" + this.curData + ")"
      this.levelTitle = this.language['danger.level.table']  + "(" + this.curData + ")"
      this.typeTitle =  this.language['danger.type.table'] + "(" + this.curData + ")"

    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['common.serialNumber'],
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: 'center',
              customRender: function(t, r, index) {
                return parseInt(index) + 1
              }
            },
            {
              title: this.language['todo.type'],
              align: 'center',
              sorter: true,
              dataIndex: 'name'
            },
            {
              title: this.language['number'],
              align: 'center',
              sorter: true,
              dataIndex: 'count'
            },
            {
              title: this.language['common.detailsButton'],
              align: 'center',
              sorter: true,
              //   dataIndex: 'dangerNo',
              scopedSlots: { customRender: 'details' }
            }
          ]
        }
      }
    },
    methods:{
      getNowDate() {
        let month = parseInt(new Date().getMonth()) + 1;
        return new Date().getFullYear() + "/" + month + "/" + new Date().getDate();
      },
      getOneMonthDate() {
        const dates = new Date()
        dates.setMonth(dates.getMonth() - 1)
        let pastMonth = dates.getMonth() + 1
        let pastDay = dates.getDate()
        if (pastMonth >= 1 && pastMonth <= 9) {
          pastMonth = '0' + pastMonth
        }
        if (pastDay >= 0 && pastDay <= 9) {
          pastDay = '0' + pastDay
        }
        const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
        return endDate
        //return new Date().getFullYear()+"/"+new Date().getMonth()+"/"+new Date().getDate();
      },


      //查看详情-隐患整改
      showCheckTableInfo(record) {
        if (this.language['todo.sign'] == record.name) {
          this.$router.push({ path: "/eletronicSigned/MyTodoList" });
          console.log(record.name)
        }
        if (this.language['todo.rectify'] == record.name) {
          this.$router.push({ path: "/epdanger/EpDangerRectifyList" });
          console.log(record.name)
        }
      },
      //查看详情-隐患状态分析
      showStateTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerStateReportTo" });
      },
      //查看详情-隐患程度分析
      showLevelTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerLevelReportTo" });
      },
      //查看详情-隐患类型分析
      showTypeTableInfo() {
        this.$router.push({ path: "/epreport/EpDangerTypeReportTo" });
      },

      getTodoList() {
        getAction(this.url.todo_list, this.queryParam).then((res) => {
          let records = res.result.records || res.result
          console.log('records-->',records)
          if (records == 0) {
            let item = { 'name':this.language['todo.sign'], 'count': 0 }
            this.sourceBacklog.push(item)
          } else {
            let len = records.length || records
            let item = { 'name': this.language['todo.sign'], 'count': len }
            this.sourceBacklog.push(item)
          }
        })
      },

      getDangerList() {
        getAction(this.url.danger_list, { pageNo: 1, pageSize: 1000 ,inspectFlag:0,appCode:'env_audit'}).then((res) => {
          let records = res.result.records
          let len = records.length

          let item = { 'name': this.language['to.rectity'], 'count': len }
          this.sourceBacklog.push(item)

        })
      },

      //隐患程度报表数据
      getDangerLevel() {
        postAction(this.url.list,this.parm).then((res) => {
          if (res.code == 200) {
            let records = res.result.records || res.result
            if (records.length > 0) {
              for (var index in records) {

                let obj = records[index]

                let item1 = {item:this.language['levelNum1'], count: obj.levelNum1};
                let item2 = {item:this.language['levelNum2'], count: obj.levelNum2};
                let item3 = {item:this.language['levelNum3'], count: obj.levelNum3};
                let item4 = {item:this.language['levelNum4'], count: obj.levelNum4};

                this.sourceDataLevel.push(item1)
                this.sourceDataLevel.push(item2)
                this.sourceDataLevel.push(item3)
                this.sourceDataLevel.push(item4)
              }
            } else {
              this.defaultLevelData
            }
          } else {
            this.defaultLevelData
          }
        })
      },

      getDangerType() {
        postAction(this.url.listUnit, this.parm).then((res) => {
          if (res.success) {
            const result = res.result.records || res.result
            this.dataSource = result.map((v, i)=>{
              v.key = i + 1;
              return v;
            }) || res.result;

            postAction(this.url.report_type_list, this.parm).then((res2) => {
              if (res2.success) {
                const result = res2.result.records || res2.result
                this.dataList = result.map((v, i)=>{
                  v.key = i + 1;
                  return v;
                }) || res.result;

                console.log("datalist ******** 1111" , this.dataList);
                this.total.MF = this.dataList.filter(function(item){ return item.dangerType == "MF"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TW = this.dataList.filter(function(item){ return item.dangerType == "TW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TA = this.dataList.filter(function(item){ return item.dangerType == "TA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TN = this.dataList.filter(function(item){ return item.dangerType == "TN"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TS = this.dataList.filter(function(item){ return item.dangerType == "TS"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TR = this.dataList.filter(function(item){ return item.dangerType == "TR"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TH = this.dataList.filter(function(item){ return item.dangerType == "TH"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DW = this.dataList.filter(function(item){ return item.dangerType == "DW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DA = this.dataList.filter(function(item){ return item.dangerType == "DA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EO = this.dataList.filter(function(item){ return item.dangerType == "EO"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EM = this.dataList.filter(function(item){ return item.dangerType == "EM"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.sumTotal = parseInt(this.total.MF) + parseInt(this.total.TW)+parseInt(this.total.TA)+parseInt(this.total.TN)+parseInt(this.total.TS) +parseInt(this.total.TR) + parseInt(this.total.TH) +parseInt(this.total.DW)+parseInt(this.total.DA)+parseInt(this.total.EO)+ parseInt(this.total.EM);

                console.log("datalist ******** 222" + this.dataList);

                console.log("datalist ******** 333" + this.dataList);

                let attr=['MF','TW','TA','TN','TS','TR','TH','DW','DA','EO','EM'];
                attr.forEach((k)=>{
                  let levelitem = {item:k,count:0};
                  if (this.dataList == 0)
                  {
                    this.sourceDataType.push(levelitem);
                  }
                  else
                  {
                    if(k=="MF")
                    {
                      levelitem['count']=this.total.MF;
                    }
                    else if(k=="TW")
                    {
                      levelitem['count']=this.total.TW;
                    }
                    else if(k=="TA")
                    {
                      levelitem['count']=this.total.TA;
                    }
                    else if(k=="TN")
                    {
                      levelitem['count'] = this.total.TN;
                    }
                    else if(k=="TS")
                    {
                      levelitem['count'] = this.total.TS;
                    }
                    else if(k=="TR")
                    {
                      levelitem['count'] = this.total.TR;
                    }
                    else if(k=="TH")
                    {
                      levelitem['count'] = this.total.TH;
                    }
                    else if(k=="DW")
                    {
                      levelitem['count'] = this.total.DW;
                    }
                    else if(k=="DA")
                    {
                      levelitem['count'] = this.total.DA;
                    }
                    else if(k=="EO")
                    {
                      levelitem['count'] = this.total.EO;
                    }
                    else if(k=="EM")
                    {
                      levelitem['count'] = this.total.EM;
                    }
                    this.sourceDataType.push(levelitem);
                  }
                });

                console.log('11111111 sourceDataType --->' , this.sourceDataType)
                if (this.dataSource.length ==0) {
                  this.fields_list.push('');   //没有数据，默认
                } else {
                  this.dataSource.forEach((item)=>{
                    this.fields_list.push(item.businessUnitName);
                  });
                }

                console.log('33333 fields_list --->' , this.fields_list)

               /*const DataSet = require('@antv/data-set');
                const dv = new DataSet.View().source(this.sourceDataType);
                dv.transform({
                  type: 'fold',
                  fields: this.fields_list,
                  key: '事业处',
                  value: '隐患数量',
                });
                this.data = dv.rows;*/

              }else{
                this.$message.warning(res.message)
              }
            }).finally(() => {
              // this.loading = false;
              // this.fields =[];
              //this.sourceData=[];
            });
          }else{
            this.$message.warning(res.message)
          }
        })
      },

      //隐患状态报表数据
      getDangerState() {
        postAction(this.url.report_state_list,this.parm).then((res) => {
          if (res.code == 200) {
            let records = res.result.records || res.result
            if (records.length > 0) {
              for (var index in records) {

                let obj = records[index]

                let item1 = {item:this.language['signedState'], count: obj.signedState};
                let item2 = {item:this.language['deferSignState'], count: obj.deferSignState};
                let item3 = {item:this.language['deferConfirmState'], count: obj.deferConfirmState};
                let item4 = {item: this.language['rectifyedState'], count: obj.rectifyedState};
                let item5 = {item:this.language['archivePassState'], count: obj.archivePassState};

                this.sourceDataState.push(item1)
                this.sourceDataState.push(item2)
                this.sourceDataState.push(item3)
                this.sourceDataState.push(item4)
                this.sourceDataState.push(item5)
              }
            } else {
              this.defaultStateData()
            }

          } else {
            this.defaultStateData()
          }

        })
      },

      defaultLevelData() {
        let item1 = {item:this.language['levelNum1'], count:0};
        let item2 = {item:this.language['levelNum2'], count: 0};
        let item3 = {item:this.language['levelNum3'], count: 0};
        let item4 = {item:this.language['levelNum4'], count:0};

        this.sourceDataLevel.push(item1)
        this.sourceDataLevel.push(item2)
        this.sourceDataLevel.push(item3)
        this.sourceDataLevel.push(item4)
      },

      defaultStateData() {
        let item1 = {item:this.language['signedState'], count: 0};
        let item2 = {item:this.language['deferSignState'], count: 0};
        let item3 = {item:this.language['deferConfirmState'], count: 0};
        let item4 = {item: this.language['rectifyedState'], count: 0};
        let item5 = {item:this.language['archivePassState'], count: 0};

        this.sourceDataState.push(item1)
        this.sourceDataState.push(item2)
        this.sourceDataState.push(item3)
        this.sourceDataState.push(item4)
        this.sourceDataState.push(item5)
      }
    }
  }
</script>

<style lang="less" scoped>

</style>